module.exports = __webpack_public_path__ + "static/media/sundorbon.978671e9.png";